import { render, staticRenderFns } from "./InvoiceListPage.vue?vue&type=template&id=38c81348&scoped=true&"
import script from "./InvoiceListPage.vue?vue&type=script&lang=ts&"
export * from "./InvoiceListPage.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceListPage.vue?vue&type=style&index=0&id=38c81348&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c81348",
  null
  
)

export default component.exports